export default __webpack_public_path__ + "static/media/EcoRent.f7ea1da9.svg";